import { findFieldByElement } from './lib/findFieldByElement';
import { extractAddressParts } from './lib/extractAddressParts';

export const submissionKey = (submissionId, sessionId) => ['submission', submissionId, sessionId];

export const paymentKey = (paymentId, sessionId) => ['payment', paymentId, sessionId];

export const eventPaymentKey = (paymentId, sessionId) => ['event_payment', paymentId, sessionId];

export const bookingGuestsKey = (paymentId, sessionId) => ['booking_guests', paymentId, sessionId];

export const subscriptionKey = (subscriptionId, sessionId) => [
  'subscription',
  subscriptionId,
  sessionId,
];

export const checkoutKey = (sellerId, checkoutId, previewKey, hasAuthToken) =>
  ['checkout', sellerId, checkoutId, previewKey, hasAuthToken ? 'auth' : 'no-auth'].filter(Boolean);

export const sellerKey = sellerId => ['seller', sellerId];

export const countryKey = ['country'];

export const previewStylesheetKey = href => ['preview_stylesheet', href];

export const templateKey = pageId => ['template', pageId];

export const checkoutEventKey = (pageId, checkoutId) => ['checkout_event', pageId, checkoutId];

export const taxCalculationQueryKey = ({
  sellerId,
  pageId,
  priceId,
  fields,
  variants,
  tickets,
  ticketPwywAmounts,
  couponId,
  customerId,
  payWhatYouWantPrice,
  dynamicPrice,
  selectedPaymentMethod,
  orderBumps,
}) => {
  const taxIdField = findFieldByElement(fields, 'tax-id');
  const taxIdType = taxIdField?.meta?.type;
  const taxId = taxIdField?.value;

  const { country, state, postalCode } = extractAddressParts(fields, 'shipping');

  const arr = Array.isArray(fields) ? fields : Object.values(fields);
  const quantityField = arr.find(field => field.element === 'quantity');

  const variantsKey = Object.entries(variants)
    .map(([variantId, value]) => {
      if (typeof value === 'string') {
        return `${variantId}:${value}`;
      }

      if (Array.isArray(value)) {
        return `${variantId}:${value.map(opt => `${opt.optionId}=${opt.quantity || 0}${opt.payWhatYouWantAmount != null ? `:pwyw=${opt.payWhatYouWantAmount}` : ''}`).join('|')}`;
      }

      // PWYW single-select: value is { optionId, payWhatYouWantAmount }
      if (value && typeof value === 'object') {
        return `${variantId}:${value.optionId || ''}:pwyw=${value.payWhatYouWantAmount || ''}`;
      }

      return `${variantId}:`;
    })
    .join(',');

  const ticketsKey = Object.entries(tickets)
    .map(
      ([key, value]) =>
        `${key}:${value}${ticketPwywAmounts?.[key] != null ? `:pwyw=${ticketPwywAmounts[key]}` : ''}`,
    )
    .join(',');

  const orderBumpsKey = (orderBumps || [])
    .map(
      ({ productId, quantity, payWhatYouWantAmount }) =>
        `${productId}:${quantity}${payWhatYouWantAmount != null ? `:pwyw=${payWhatYouWantAmount}` : ''}`,
    )
    .join(',');

  return [
    'taxCalculation',
    sellerId,
    pageId,
    priceId,
    variantsKey,
    ticketsKey,
    country,
    postalCode,
    state,
    quantityField?.value,
    taxIdType,
    taxId,
    couponId,
    customerId,
    payWhatYouWantPrice,
    selectedPaymentMethod,
    dynamicPrice,
    // Appended (not inserted) so the earlier positions stay stable.
    orderBumpsKey,
  ];
};

export const prorationCalculationQueryKey = ({
  sellerId,
  pageId,
  variants,
  quantity,
  selectedPaymentMethod,
  couponId,
  priceId,
  billingCycleAnchorConfigEnabled,
  dayOfMonth,
  month,
}) => [
  'proration',
  sellerId,
  pageId,
  variants,
  quantity,
  selectedPaymentMethod,
  couponId,
  priceId,
  billingCycleAnchorConfigEnabled,
  dayOfMonth,
  month,
];
